import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Helmet from 'react-helmet';
import * as _ from 'lodash';
import { setProducts } from 'redux/modules/products';
import { addContract, editContract } from 'redux/modules/newContract';
import { GrayButton, ModalTopBar, SecondaryButton, PageHeader, Spinner } from 'components';
import { connect } from 'react-redux';
import { LeftNavLayout } from 'containers';
import { NewPartnerForm, NewPartnerTotals } from 'containers/PartnerAgreements';
import * as styles from './NewPartnerAgreement.scss';

var moment = require('moment');

var NewPartnerAgreement = (_dec = connect(function (state) {
  return {
    contract: state.contract,
    organization: state.organization.current,
    allContracts: state.contract.allContracts,
    isLoadingContracts: state.contract.isLoadingContracts,
    theme: state.theme,
    products: state.products.agreementProducts,
    emailAvailability: state.contract.emailAvailability
  };
}, {
  addContract: addContract,
  editContract: editContract,
  setProducts: setProducts
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewPartnerAgreement, _Component);

  var _super = _createSuper(NewPartnerAgreement);

  function NewPartnerAgreement(props) {
    var _this;

    _classCallCheck(this, NewPartnerAgreement);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleLeave", function () {
      var result = window.confirm('Are you sure you want to leave? You will lose all changes.');

      if (result) {
        browserHistory.push('/global/agreements');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFormFieldChange", function (field, val) {
      var change = _objectSpread(_objectSpread({}, _this.state.formValues), {}, _defineProperty({}, field, val));

      for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }

      if (rest && rest.length > 0) {
        for (var i = 0; i < rest.length; i += 2) {
          change[rest[i]] = rest[i + 1];
        }
      }

      _this.setState({
        formValues: _objectSpread({}, change)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "requiredFields", ['firstName', 'lastName', 'email', 'businessName', 'phone']);

    _defineProperty(_assertThisInitialized(_this), "validateRequired", function (val) {
      return val !== '';
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      var values = _.cloneDeep(_this.state.formValues); // validate


      var errorMessage = '';

      _this.requiredFields.forEach(function (f) {
        var valid = _this.validateRequired(values[f]);

        if (!valid) {
          errorMessage += "".concat(f, " is required.\n");
        }
      });

      if (!_this.props.emailAvailability) errorMessage += 'Email is already registered.';

      if (errorMessage !== '') {
        alert(errorMessage);
      } else {
        // convert to ints
        values.monthlyFee = parseInt(values.monthlyFee, 10);
        values.initialTeamMembers = parseInt(values.initialTeamMembers, 10);
        values.initialTeamMembersMonthlyPrice = parseInt(values.initialTeamMembersMonthlyPrice, 10);
        values.additionalTeamMembersMonthlyPrice = parseInt(values.additionalTeamMembersMonthlyPrice, 10);
        values.initialClients = parseInt(values.initialClients, 10);
        values.initialClientsMonthlyPrice = parseInt(values.initialClientsMonthlyPrice, 10);
        values.additionalClientsMonthlyPrice = parseInt(values.additionalClientsMonthlyPrice, 10); // trim names

        values.firstName = values.firstName.trim();
        values.lastName = values.lastName.trim();

        if (_this.state.formValues.partnerType === 'affiliate') {
          values.products = _.cloneDeep(_this.props.products);
        }

        _this.setState({
          sendingContract: true
        });

        if (_this.props.isEdit) {
          _this.props.editContract(values).then(function (savedcontract) {
            browserHistory.push("/global/agreements/".concat(savedcontract.data.uuid, "/teamview/"));
          })["catch"](function (err) {
            console.error(err);
          });
        } else {
          _this.props.addContract(values).then(function (savedcontract) {
            browserHistory.push("/global/agreements/".concat(savedcontract.uuid, "/teamview"));
          });
        }
      }
    });

    var isEdit = _this.props.isEdit;
    var c = _this.props.contract;
    var cp = isEdit ? c.ContractPartners[0] : null;
    props.setProducts(isEdit ? c.products : []);
    var partnerType = isEdit ? props.contract.isPartner && props.contract.ContractPartners && props.contract.ContractPartners.length && props.contract.ContractPartners[0].partnerType : props.partnerType ? props.partnerType : null;
    _this.state = {
      disableBack: false,
      disableSubmit: false,
      sendingContract: false,
      formValues: {
        partnerType: partnerType,
        firstName: isEdit ? c.firstName : '',
        lastName: isEdit ? c.lastName : '',
        email: isEdit ? c.email : '',
        businessName: isEdit ? c.businessName : '',
        whitelabelSubdomain: isEdit ? cp.whitelabelSubdomain : '',
        address1: isEdit ? c.Address.address1 : '',
        address2: isEdit ? c.Address.address2 : '',
        locality: isEdit ? c.Address.locality : '',
        region: isEdit ? c.Address.region : '',
        postcode: isEdit ? c.Address.postcode : '',
        phone: isEdit ? c.phone : '',
        monthlyFee: isEdit && cp.monthlyFee ? cp.monthlyFee : '299',
        initialTeamMembers: isEdit ? cp.initialTeamMembers && cp.initialTeamMembers : '0',
        initialTeamMembersMonthlyPrice: isEdit && cp.initialTeamMembersMonthlyPrice ? cp.initialTeamMembersMonthlyPrice : '49',
        additionalTeamMembersMonthlyPrice: isEdit && cp.additionalTeamMembersMonthlyPrice ? cp.additionalTeamMembersMonthlyPrice : '49',
        initialClients: isEdit && cp.initialClients ? cp.initialClients : '0',
        initialClientsMonthlyPrice: isEdit && cp.initialClientsMonthlyPrice ? cp.initialClientsMonthlyPrice : '49',
        additionalClientsMonthlyPrice: isEdit && cp.additionalClientsMonthlyPrice ? cp.additionalClientsMonthlyPrice : '49',
        partnerManagedMonthlyFee: isEdit && cp.partnerManagedMonthlyFee ? cp.partnerManagedMonthlyFee : '49',
        llManagedMonthlyFee: isEdit && cp.llManagedMonthlyFee ? cp.llManagedMonthlyFee : '99',
        contractMonths: isEdit && cp.contractMonths ? cp.contractMonths : 1,
        isPartner: true,
        contractStartsAt: isEdit && c.contractStartsAt ? moment(c.contractStartsAt).toDate() : new Date(),
        paymentMethod: {
          id: 6
        },
        uuid: isEdit ? c.uuid : null,
        paymentDetailEntryType: isEdit && c.paymentDetailEntryType ? c.paymentDetailEntryType : 2,
        businessSubdomainLink: 1,
        adsFeePercent: ['affiliate', 'multilocation'].includes(partnerType) ? 0 : isEdit && cp ? parseFloat(cp.adsFeePercent) : 25
      }
    };
    return _this;
  }

  _createClass(NewPartnerAgreement, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: '1 1 auto',
          paddingBottom: 36
        },
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'hidden',
          overflowY: 'hidden',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "".concat(this.props.isEdit ? 'Edit' : 'New', " ").concat(function () {
          switch (_this2.state.formValues.partnerType) {
            case 'multilocation':
              return 'Multilocation';

            case 'affiliate':
              return 'Affiliate';

            default:
              return 'Partner';
          }
        }(), " Agreement")
      }), /*#__PURE__*/React.createElement(ModalTopBar, {
        handleGoBack: this.handleLeave,
        showCloseBtn: false,
        style: {
          position: 'static',
          marginBottom: 24
        },
        backLabel: "View All Agreements"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid",
        style: {
          padding: 36,
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row ".concat(styles.pageHeaderRow)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "".concat(this.props.isEdit ? 'Edit' : 'New', " ").concat(function () {
          switch (_this2.state.formValues.partnerType) {
            case 'multilocation':
              return 'Multilocation';

            case 'affiliate':
              return 'Affiliate';

            default:
              return 'Partner';
          }
        }()),
        secondary: "Agreement"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.props.isSaving ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 col-sm-8 ".concat(styles.scrollSection)
      }, /*#__PURE__*/React.createElement(NewPartnerForm, {
        handleFormFieldChange: this.handleFormFieldChange,
        formValues: this.state.formValues,
        isEdit: this.props.isEdit,
        style: {
          paddingRight: 36
        },
        handleLeave: this.handleLeave,
        handleSubmit: this.handleSubmit,
        sendingContract: this.state.sendingContract,
        isMultilocationContract: this.state.formValues.partnerType === 'multilocation',
        isAffiliateContract: this.state.formValues.partnerType === 'affiliate'
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 col-sm-4"
      }, /*#__PURE__*/React.createElement(NewPartnerTotals, {
        formValues: this.state.formValues,
        isMultilocationContract: this.state.formValues.partnerType === 'multilocation',
        isAffiliateContract: this.state.formValues.partnerType === 'affiliate'
      })))))));
    }
  }]);

  return NewPartnerAgreement;
}(Component)) || _class);
export default NewPartnerAgreement;